import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import IFrameControl from "../IFrameControl";

const SectionItemFrameControl = ({ t, item, value }) => {  
    const isExistPass = !!(item.login && item.password);  
    const [inProcess, setInProcess] = useState(true);

    const handleOnLoad = e => {
        const currentTarget = e.currentTarget;

        if(isExistPass) {
            setTimeout(()=> {
                currentTarget && currentTarget.contentWindow && currentTarget.contentWindow.postMessage(JSON.stringify({ 
                    login: item.login, 
                    password: item.password,
                    url: item.urlTo
                }), value);
                
                setTimeout(()=> {
                    setInProcess(false);
                }, 2000);
            }, 1000);
        } else {
            setInProcess(false);
        }              
    }
    
    return (
        <div className={classNames("sectionItemFrameControl")}>
            {inProcess && (<div className={classNames("preloader")} />)}
            <IFrameControl value={value} onLoad={handleOnLoad} />
            {!isExistPass && !inProcess && (
                <div className={classNames("empty")}>
                    {t("settings.paymentsConfigurationSettings.LOGIN_DATA_EMPTY")}
                </div>
            )}
        </div>
    );
}

export default withTranslation()(SectionItemFrameControl);